export const LISTING = "WALLET_ADJUSTMENT_LISTING";
export const DROPDOWN = "WALLET_ADJUSTMENT_DROPDOWN";
// export const DETAILS = "WALLET_ADJUSTMENT_DETAILS";
export const BALANCE = "WALLET_ADJUSTMENT_BALANCE";
export const STORE = "WALLET_ADJUSTMENT_STORE";